<template>
  <div>
    <v-row>
      <v-col 
        cols="12"
        md="12"
        class="py-0">
        <v-tabs
          v-model="selected.menu"
          fixed-tabs
          slider-size="4"
          :color="set_color"
          :background-color="set_color_rgb_soft"
          style="border-radius: 8px 8px 0px 0px !important;">
          <v-tab
            v-for="(item, index) in menu"
            :key="index"
            @click="changeQuery(item.link)">
            <div
              class="text-capitalize"
              :class="selected.menu === index ? 'font-weight-bold' : ''">
              {{ item.text }}
            </div>
          </v-tab>
        </v-tabs>
      </v-col>
    </v-row>

    <div>
      <Pengajian v-if="selected.menu === 0" />

      <Pengembangan v-if="selected.menu === 1" />

      <Hafalan v-if="selected.menu === 2" />

      <Keterlibatan v-if="selected.menu === 3" />

      <!-- <Lainnya v-if="selected.menu === 3" /> -->
    </div>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  export default {
    data () {
      return {
        selected: {
          menu: 0
        },

        menu: [],

        process: {
          load: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      Pengajian: () => import(/* webpackPrefetch: true */ '@/components/aik/pengajian.vue'),
      Hafalan: () => import(/* webpackPrefetch: true */ '@/components/aik/hafalan.vue'),
      Keterlibatan: () => import(/* webpackPrefetch: true */ '@/components/aik/keterlibatan.vue'),
      // Lainnya: () => import(/* webpackPrefetch: true */ '@/components/aik/lainnya.vue')
      Pengembangan: () => import(/* webpackPrefetch: true */ '@/components/aik/pengembangan_ekonomi.vue')
    },
    computed: {
      rps() {
        return this.$vuetify.breakpoint.name
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.2)`
      },
      set_color_rgb_soft () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.1)`
      }
    },
    watch: {
      
    },
    beforeMount () {
      this.changeLink(this.$route.query.menu)
    },
    mounted () {
      this.fetchIndicator()
    },
    methods: {
      async fetchIndicator () {
        let params = {
          limit: 100000,
          par_id: 2,
          // 'id[neq]': 8
        }

        this.menu = []

        await get('admin/indicator/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            res.results.data.map((obj, index) => {
              this.menu.push({
                text: obj.name,
                value: obj.id,
                link: `/evaluation/officer/aik?menu=${index}&indicator=${obj.id}`
              })
            })

            // this.menu.push({
            //   text: 'Kegiatan Lainnya',
            //   value: 14,
            //   link: `/evaluation/officer/aik?menu=4&indicator=14`
            // })
          }
        })
      },
      changeLink (query) {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
        
        if (query !== undefined) {
          this.selected.menu = parseInt(query)
        }
      },
      changeQuery (link) {
        this.$router.push(link)
      }
    }
  }
</script>